/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 * Amina Rais - Initial implementation
 * Version: 1.0.0
 *
 *******************************************************************************/
import React, { useEffect, useCallback } from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useLocation, useNavigate } from 'react-router-dom'; 
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useDispatch, useSelector } from 'react-redux';
import { getUserInfo } from '../../store/reducers/user/userAction';
import { initializedSuccess } from '../../store/reducers/initialized/initializedSlice';
import PageHeader from './PageHeader';
import PageFooter from './PageFooter';
import MenuSideBar from './MenuSideBar';
import { BrowserView, isMobile } from 'react-device-detect';

const Layout = ({ children }) => {
  const loginned = useSelector((state) => state.user.loginned);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { classes } = useStyles();
  const auth = getAuth();

  
  // Initialize app function with useCallback
  const initializeApp = useCallback(async () => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      const userInfoAction = await dispatch(getUserInfo());
      const userInfo = userInfoAction.payload;
      if (user && userInfo && Object.keys(userInfo).length > 0) {
        try {
       
          console.log('userInfo', userInfo)
          if (userInfo && Object.keys(userInfo).length > 0 && (
            location.pathname === '/' ||
            location.pathname === '/login' ||
            location.pathname.includes('/register'))
          ) {
            navigate('/dashboard');
            dispatch(initializedSuccess());

          }
 

        } catch (error) {
          navigate('/login');

          localStorage.clear();
          window.location.reload(true);
        }
      } else {
        if (
          location.pathname !== '/login' &&
          location.pathname !== '/tos' &&
          location.pathname !== '/privacypolicy' &&
          location.pathname !== '/contact' &&
          location.pathname !== '/about' &&
          !location.pathname.includes('/register')
        ) {

          navigate('/login');
        }
      }
    });

    return () => unsubscribe(); // Return unsubscribe function
  }, [auth, dispatch, location.pathname, navigate]);


  useEffect(() => {
    initializeApp();

  }, [initializeApp]);

  return (
    <>
      <div className={classes.layout}>
        <PageHeader />
        <main className={classes.main} style={{ marginLeft: isMobile ? '0px' : '80px' }}>
          <BrowserView>{loginned && <MenuSideBar />}</BrowserView>
          <Grid container justify="center">
            <Grid container className={classes.gridInner}>
              <Grid item sm={12} xs={12} md={12} className={classes.maxWidthDiv}>
                {children}
              </Grid>
            </Grid>
          </Grid>
        </main>
        <PageFooter />
      </div>
    </>
  );
};

const useStyles = makeStyles({ "name": { Layout } })((theme) => ({
  layout: {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.grayed,
    backgroundImage: 'url(/assets/images/bg/bg.png)',
    backgroundSize: 'auto',
    backgroundAttachment: 'fixed',
  },
  main: {
    flex: 1,
    marginBottom: '10px',
  },
  gridInner: {
    maxWidth: '100%',
  },
  maxWidthDiv: {
    width: '100%',
  },
}));

export default Layout;
